import { TextField } from "@material-ui/core"
import { Autocomplete } from "@material-ui/lab"
import { useDispatch } from "react-redux"
import useApi from "../../../../hooks/useAPI"
import handleRenderOption from "./handleRenderOption"
import { clienteTargetAction, accionTargetAction, obtenerCotizacionAction, obtenerComprasAction } from "../../../../ducks/cambiosDuck"
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import BackDrop from "../../../../global/BackDrop"
const InitialValueCliente = {
    referencia: "",
    idCotizacion: 0,
    cliente: {},
}

const BCliente = () => {
    const clientes = useApi("Trip/Listado")
    const dispatch = useDispatch()
    const { Referencia } = useParams()
    const [load, setLoad] = useState(false)
    const getOptionHangle = (event, valor) => {
        if (valor) {
            setLoad(true)
            dispatch(clienteTargetAction({ cliente: valor, referencia: valor.Movimiento?.Referencia })).then(Response => {
                setLoad(false)
                dispatch(obtenerCotizacionAction({Referencia: valor.Movimiento?.Referencia }))
                dispatch(obtenerComprasAction({IdPaquete: valor.paquete?.Id_Paquete }))
            })
        } else {
            dispatch(clienteTargetAction({ cliente: InitialValueCliente, referencia: InitialValueCliente.referencia }))
            dispatch(accionTargetAction({ accion: 0 }))
        }
    }

    useEffect(() => {
        const check = () => {
            setLoad(true)
            dispatch(clienteTargetAction({ cliente: clientes.find(cliente => cliente.Movimiento?.Referencia === Referencia), referencia: Referencia })).then(Response => {
                setLoad(false)
            })
        }
        if (clientes.length > 0 && Referencia) {
            setLoad(true)
            check()
        }
        return () => {
            setLoad(false)
            dispatch(clienteTargetAction({ cliente: InitialValueCliente, referencia: InitialValueCliente.referencia }))
            dispatch(accionTargetAction({ accion: 0 }))
        }
    }, [dispatch, clientes, Referencia])

    if (Referencia)
        return <BackDrop open={load} message="Obteniendo información" />

    return (
        <div>
            <Autocomplete
                id={`id-auto-Clientes`}
                options={clientes.sort((a, b) => a.Nombre > b.Nombre)}
                getOptionLabel={(option) => {
                    let nombre = option?.Titular ?? `${option.Movimiento?.Cuenta?.Nombre.trim()} ${option.Movimiento?.Cuenta?.Apellido_Paterno.trim()}`
                    return `${option.Movimiento?.Referencia} - ${option.paquete?.Nombre} - ${nombre}`
                }}
                style={{
                    width: "50%",
                    margin: "5px 0",
                    paddingBottom: "0",
                    fontWeight: "500",
                }}
                disabled={clientes.length > 0 ? false : true}
                onChange={getOptionHangle}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Clientes"
                        variant="outlined"
                        style={{ width: "100%" }}
                        name="clientes"
                    />
                )}
                renderOption={handleRenderOption}
            />
            <BackDrop open={load} message="Obteniendo información" />
        </div>
    )
}
export default BCliente